import { useEffect, useMemo, useState } from "react"
import { getUsage, getUsers } from "./api"
import firebase from "firebase/app";
import { startOfMonth } from "date-fns";


export function useUserUsage({ email, fbUser }: { email: string, fbUser: firebase.User; }) {
    const [userId, setUserId] = useState<string | undefined>(undefined)
    const [usage, setUsage] = useState<number | undefined>(undefined)

    const fromTimestamp = useMemo(() => startOfMonth(new Date()).getTime(), []);
    const toTimestamp = useMemo(() => Date.now(),[]);

    useEffect(() => {
        fbUser.getIdToken().then((idToken) => getUsers(idToken)({ email, role: '', group: '' }))
            .then(response => response.json())
            .then(({ users }) => {
                setUserId(users[0]?.uid);
            }).catch(e => {
                console.log(e);
            })
    }, [email, fbUser])

    useEffect(() => {
        if (userId) {
            fbUser.getIdToken().then((token) => getUsage(token)({ userId, fromTimestamp, toTimestamp}))
                .then(response => response.json())
                .then(({ entries }) => {
                    setUsage(entries[0]?.sessionHoursUsed ?? 0);
                }).catch(e => {
                    console.log(e);
                })
        }
    }, [userId, fromTimestamp, toTimestamp, fbUser])

    return {
        sessionHoursUsed: usage
    }
}